<div class="w-full bg-primary-container rounded-lg border border-outline/20 overflow-hidden relative min-h-[400px] flex items-center justify-center">
  @if (drawingUrl()) {
    <div class="relative inline-block w-full">
      <img #drawingImg [src]="drawingUrl()" class="w-full h-auto select-none" (load)="onImageLoad($event)" alt="現場配置図" (dragstart)="$event.preventDefault()">
      
      <div class="absolute top-0 left-0 w-full h-full pointer-events-none canvas-boundary overflow-hidden">
        @for (sensor of sensors(); track sensor.id) {
          <div cdkDrag
               [cdkDragFreeDragPosition]="dragPositions().get(sensor.id)!"
               (cdkDragEnded)="onDragEnded($event, sensor)"
               cdkDragBoundary=".canvas-boundary"
               class="absolute top-0 left-0 w-10 h-10 -ml-5 -mt-5 cursor-move z-10 flex flex-col items-center justify-center pointer-events-auto transition-transform hover:scale-110 group"
               tabindex="0"
               role="button"
               [attr.aria-label]="sensor.categoryName + ' (' + sensor.id + ')'"
               title="{{ sensor.categoryName }} ({{ sensor.id }})">
            
            <div class="bg-primary text-on-primary rounded-full w-8 h-8 flex items-center justify-center shadow-md border-2 border-surface">
              <mat-icon class="text-sm">sensors</mat-icon>
            </div>
            
            <!-- Tooltip/Label -->
            <div class="absolute top-full mt-1 bg-surface-container-highest text-on-surface text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 whitespace-nowrap shadow-sm pointer-events-none transition-opacity">
              {{ sensor.categoryName }}
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="text-center text-on-surface-variant/60 p-12">
      <mat-icon class="text-6xl mb-4 opacity-50">map</mat-icon>
      <p class="text-lg">配置図がアップロードされていません</p>
      <p class="text-sm mt-2">画像をアップロードしてセンサーを配置しましょう</p>
    </div>
  }
</div>
